import { render } from "./detail-dashboard.vue?vue&type=template&id=def1f730"
import script from "./detail-dashboard.vue?vue&type=script&lang=js"
export * from "./detail-dashboard.vue?vue&type=script&lang=js"

import exportComponent from "/home/Work/max/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__